import { NavigationSettings } from "../models/navigation-settings.model";
import * as NavigationSettingsActions from "../actions/navigation-settings.actions";

const initialState: NavigationSettings = {
  pageParams: {
    pageName: "",
  },
};

export function navigationSettingsReducer(
  state: NavigationSettings = initialState,
  action: NavigationSettingsActions.Actions,
) {
  switch (action.type) {
    case NavigationSettingsActions.SET_PAGE_PARAMS:
      return {
        ...state,
        pageParams: { ...action.payload },
      };

    case NavigationSettingsActions.GET_PAGE_PARAMS:
      return state;

    default:
      return state;
  }
}
